module.exports = __webpack_public_path__ + "fonts/proximanova-semibold-webfont.82f6fd53.eot";